// extracted by mini-css-extract-plugin
module.exports = {"salesforceLogo":"onboarding_salesforceLogo__1ObEc"};